import React from 'react'
import {Link} from 'react-router-dom'
import {IoMenu} from 'react-icons/io5'
import {LinkComponent, SocialLinkComponent} from '../utils/links'
import {useGlobalContext} from '../context'


function Navbar() {
    const {openSidebar} = useGlobalContext();
    return (
        <nav className="nav">
            <header className="nav-header">
                <Link to="/" className="nav-title">
                    <h3>Ceppo Trekking</h3>
                </Link>
            </header>
            <LinkComponent classLink={"link-component"}/>
            <SocialLinkComponent classSocial={"social-component"}/>
            <div className="sidebar-open">
                <IoMenu onClick={openSidebar}/>
            </div>
        </nav>
    )
}

export default Navbar
